import React from 'react';

import { Button, Close, Container, Window } from './styles';

export default function Modal({
  isVisible = false,
  renderText = () => null,
  onPress = undefined,
  onClose = () => {},
  buttonText,
}) {
  if (!isVisible) return null;

  return (
    <Container>
      <Window>
        {renderText()}
        {buttonText && <Button onClick={() => onPress()}>{buttonText}</Button>}
        <Close onClick={onClose}>x</Close>
      </Window>
    </Container>
  );
}
